var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2C0 0.895431 0.895431 0 2 0H16C17.1046 0 18 0.895431 18 2V8.99902C18 8.99967 18 9.00033 18 9.00098V16C18 17.1046 17.1046 18 16 18H9.00098C9.00033 18 8.99967 18 8.99902 18H2C0.895431 18 0 17.1046 0 16V2ZM11.4142 16H16V11.4142L11.4142 16ZM16 8.58579L8.58579 16H2V2H16V8.58579Z",
    fill: "#AEB5BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.ee1be0fb6b6288dd2a62028d88a02668.svg";
export { ForwardRef as ReactComponent };